const initialState = {
  // Changing Pass Word
  isChangingPassword: false,

  // Getting User Role
  isGettingUserDetails: false,
  userDetails: null,
};

const HeaderReducer = (state = initialState, action) => {
  switch (action.type) {
    // Change Password
    case "REQUEST_CHANGE_PASSWORD":
      return {
        ...state,
        isChangingPassword: true,
      };
    case "SUCCESS_CHANGE_PASSWORD":
      return {
        ...state,
        isChangingPassword: false,
      };
    case "ERROR_CHANGE_PASSWORD":
      return {
        ...state,
        isChangingPassword: false,
      };
    // Getting User Role
    case "REQUEST_USER_DETAILS":
      return {
        ...state,
        isGettingUserDetails: true,
      };
    case "SUCCESS_USER_DETAILS":
      return {
        ...state,
        isGettingUserDetails: false,
        userDetails: action?.payload,
      };
    case "ERROR_USER_DETAILS":
      return {
        ...state,
        isGettingUserDetails: false,
      };
      // From Add Invoice Screen
      case "ADDING_INVOICE":
        return {
          ...state,
          userDetails: {
            ...state?.userDetails,
            invoiceCount: state?.userDetails?.invoiceCount + 1,
          }
        }
      // From Add Bulk Invoice Screen
      case "ADDING_BULK_INVOICE":
        return {
          ...state,
          userDetails: {
            ...state?.userDetails,
            invoiceCount: state?.userDetails?.invoiceCount + action?.payload,
          }
        }
        // From Deleting Invoice Screen
      case "DELETING_INVOICE":
        return {
          ...state,
          userDetails: {
            ...state?.userDetails,
            invoiceCount: state?.userDetails?.invoiceCount - action?.payload,
          }
        }
      // From Add Company Screen
      case "ADDING_COMPANY":
        return {
          ...state,
          userDetails: {
            ...state?.userDetails,
            companyCount: state?.userDetails?.companyCount + 1,
          }
        }
        // From Deleting Company Screen
      case "DELETING_COMPANY":
        return {
          ...state,
          userDetails: {
            ...state?.userDetails,
            companyCount: state?.userDetails?.companyCount - 1,
          }
        }
    default:
      return state;
  }
};

export default HeaderReducer;
